"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const users_service_1 = require("../../../../shared/users/users.service");
let CustomTemplateTaskComponent = class CustomTemplateTaskComponent {
    constructor(usersService) {
        this.userSelection = {};
        this.userSelectionInit = '';
        this.ready = false;
        this.addTask = () => {
            this.template.createTask = {
                taskDescription: '',
                taskTitle: '',
                users: [],
            };
        };
        this.removeTask = () => {
            delete this.template.createTask;
        };
        this.parseUserIds = (array) => array.map((a) => parseInt(a, 10));
        usersService.getUsers().forEach((u) => {
            this.userSelection[u.id] = `${u.first_name} ${u.last_name}`;
        });
    }
    ngOnInit() {
        if (this.template.createTask) {
            this.userSelectionInit = this.template.createTask.users.map((u) => `${u}`).join(',');
        }
        this.ready = true;
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], CustomTemplateTaskComponent.prototype, "template", void 0);
CustomTemplateTaskComponent = __decorate([
    (0, core_1.Component)({
        selector: 'custom-template-task',
        templateUrl: require('./custom-template-task.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _a : Object])
], CustomTemplateTaskComponent);
exports.default = CustomTemplateTaskComponent;
